
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSelect, AppTable } from '@/components';
import { usePromotionBoosterEdit } from '@/modules/promotion/booster/model/edit';
import { Options as BoosterOptions } from '@/modules/booster/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.BOOSTER.EDIT,
    components: { AppFormRow, AppInput, AppButton, AppCard, AppSelect, AppTable },
    setup() {
        const { v$, model, promotionOption, actions } = usePromotionBoosterEdit();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: BoosterOptions.ItemType },
                { type: TableColumnType.RouterLink, label: 'Name', key: 'name', to: row => row.link },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' }
            ]
        };

        return { v$, model, table, promotionOption, actions };
    }
});
